export function widgetContextChanged(key: string, value: unknown) {
  const ref = document.querySelector(".msem-widget-root");
  if (!ref) return;
  const event = new CustomEvent("widgetContextChanged", { detail: { [key]: value }, bubbles: true });
  ref.dispatchEvent(event);
}
